import { QRCodeSVG } from 'qrcode.react';
import { API } from '@unboared/react';

import styles from './QRCodeViewBOD.module.css';

export default function QRCodeViewBOD() {
    return (
        <div className={styles.container}>
            <video className={styles.video} src="/assets/video/UB_Bordeaux.mp4" autoPlay loop muted playsInline />
            <div className={styles.qrContainer}>
                <h2 className={styles.title}>SCAN ME TO PLAY FOR FREE</h2>
                <p className={styles.subtitle}>SCANNEZ-MOI POUR JOUER GRATUITEMENT</p>
                <QRCodeSVG className={styles.qrcode} value={API.getSessionLink()} />
            </div>
        </div>
    );
}
